import config from "config";

const getExplorerURL = (address: string, type = "address") =>
  `https://explorer.solana.com/${type}/${address}?cluster=${config.SOLANA_CLUSTER}`;

export default getExplorerURL;
